// From board to board, and the address, which names the board on show so
// a link or a reload opens the deck on it.

export default {
  handleHashChange() {
    const index = this.nearestVisible(this.slideFromHash());
    if (index !== this.indexValue) {
      this.showSlide(index, false);
    }
  },

  slideFromHash() {
    const raw = window.location.hash.replace(/^#/, "");
    if (!raw) return 0;

    // Legacy positional form: #slide-3 → index 2.
    const positional = raw.match(/^slide-(\d+)$/);
    if (positional) {
      const num = parseInt(positional[1], 10);
      if (num >= 1 && num <= this.totalSlides) return num - 1;
      return 0;
    }

    // Semantic form: #revenue, #forecast, … If the current deck doesn't
    // render a slide with that slug (e.g. comparing a report type that
    // omits the section) fall back to the first slide.
    if (this.indexBySlug && this.indexBySlug.has(raw)) {
      return this.indexBySlug.get(raw);
    }
    return 0;
  },

  next() {
    const after = this.visibleIndices().find((i) => i > this.indexValue);
    if (after !== undefined) this.showSlide(after);
  },

  previous() {
    const before = this.visibleIndices().filter((i) => i < this.indexValue).pop();
    if (before !== undefined) this.showSlide(before);
  },

  goToSlide(index) {
    this.showSlide(index);
  },

  // A chapter button: the chapter's first board.
  jump(event) {
    const chapter = event.currentTarget.dataset.chapter;
    const first = this.visibleIndices().find((i) => this.slideTargets[i].dataset.chapter === chapter);
    if (first !== undefined) {
      this.showSlide(first);
      if (this.overview) this.toggleOverview();
    }
  },

  // The slide's semantic slug, or its position for slides without one.
  slideRef(index) {
    const slug = this.slugByIndex && this.slugByIndex[index];
    return slug || `slide-${index + 1}`;
  },
};
